import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Section } from "@/components/wizard/controls";

export const StepDetails = ({ f, set, riders, onRider }) => (
  <Section title="Rider & ride details" hint="Choose the rider and record when and where the observed ride takes place." testId="step-details">
    <div className="space-y-1.5">
      <Label>Rider</Label>
      <Select value={f.rider_id || undefined} onValueChange={onRider}>
        <SelectTrigger className="h-12" data-testid="wizard-rider-select"><SelectValue placeholder="Select rider" /></SelectTrigger>
        <SelectContent>
          {riders.map((r) => <SelectItem key={r.id} value={r.id} data-testid={`wizard-rider-option-${r.id}`}>{r.last_name}, {r.first_name}{r.membership_number ? ` (${r.membership_number})` : ""}</SelectItem>)}
        </SelectContent>
      </Select>
    </div>
    <div className="grid gap-4 sm:grid-cols-2">
      <div className="space-y-1.5">
        <Label>Assessment type</Label>
        <Select value={f.assessment_type} onValueChange={(v) => set("assessment_type", v)}>
          <SelectTrigger className="h-12" data-testid="wizard-type-select"><SelectValue /></SelectTrigger>
          <SelectContent>
            <SelectItem value="initial">Initial assessment (new rider)</SelectItem>
            <SelectItem value="reassessment">Re-assessment (check ride)</SelectItem>
          </SelectContent>
        </Select>
      </div>
      <div className="space-y-1.5">
        <Label>Date</Label>
        <Input type="date" max={new Date().toISOString().slice(0, 10)} className="h-12" value={f.date} onChange={(e) => set("date", e.target.value)} data-testid="wizard-date-input" />
      </div>
      <div className="space-y-1.5">
        <Label>Start location</Label>
        <Input className="h-12" value={f.location} onChange={(e) => set("location", e.target.value)} data-testid="wizard-location-input" />
      </div>
      <div className="space-y-1.5">
        <Label>Motorcycle (make / model / reg)</Label>
        <Input className="h-12" value={f.bike_details} onChange={(e) => set("bike_details", e.target.value)} data-testid="wizard-bike-input" />
      </div>
      <div className="space-y-1.5 sm:col-span-2">
        <Label>Weather & road conditions</Label>
        <Input className="h-12" value={f.weather} onChange={(e) => set("weather", e.target.value)} data-testid="wizard-weather-input" />
      </div>
    </div>
  </Section>
);
